import {observer} from "mobx-react";
import React from "react";
import {ContentData, ContentDataLogin, ContentInputs, ContentSelectAndCheckBox, SubContentInputs} from "./styled";
import SelectSearchMain from "@dropDesk/presentation/components/inputs/select_search_main";
import {NoticeDestiny} from "@dropDesk/domain/entities/notices/notices_enum";
import InputWithBorder from "@dropDesk/presentation/components/inputs/input_with_border";
import SelectDateAndTime from "@dropDesk/presentation/components/dates/select_date_and_time";
import {convertSQLISOToDate} from "@dropDesk/utils/helpers/date_helper";
import {useValidatorInputNotices} from "@dropDesk/presentation/pages/notices/ui/form/inputs/validator";
import {NoticesEntity} from "@dropDesk/domain/entities/notices/notices.entity";
import {destinyMap} from "@dropDesk/domain/entities/notices/notices_maps";
import SelectSearchClient from "@dropDesk/presentation/components/inputs/select_search_clients";
import {UserRole} from "@dropDesk/domain/entities/user/user_enum";
import SelectSearchUser from "@dropDesk/presentation/components/inputs/select_search_users";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";


const InputsFormNotices = observer(
    ({
         onUpdate,
         notice,
         loading,
     }: {
         onUpdate: (notice: NoticesEntity) => void,
         notice?: NoticesEntity,
         loading: boolean,
     }
    ) => {

        const {
            validate,
            errorMessageUser,
            errorMessageClient,
            errorMessageDateStarted,
            errorMessageDateEnd,
            errorMessageDescription,
        } = useValidatorInputNotices(notice);

        const resetUsersDestiny = (notice: NoticesEntity): NoticesEntity => {
            return notice.copyWith({
                idUser: null,
                idClient: null,
                user: null,
                client: null,
                replaceUserIfNull: true,
                replaceClientIfNull: true,
                replaceIdClientIfNull: true,
                replaceIdUserIfNull: true,
            })
        }

        const handleAllChanges = (event: {
            target: { name: string; value: any; checked: any; type: string }
        }, client?: ClientEntity, user?: UserEntity, removeClient?: boolean, removeUser?: boolean) => {

            const _notice = notice!.copyWith({
                [event.target.name]:
                    (event.target.type === "checkbox" || event.target.type === "switch") ? event.target.checked : event.target.value,

                idClient: client ? client.id : removeClient ? null : notice!.idClient,
                client: client ? client : removeClient ? null : notice!.client,
                replaceClientIfNull: event.target.name === "client",
                replaceIdClientIfNull: event.target.name === "client",

                idUser: user ? user.id : removeUser ? null : notice!.idUser,
                user: user ? user : removeUser ? null : notice!.user,
                replaceUserIfNull: event.target.name === "user",
                replaceIdUserIfNull: event.target.name === "user",
                replaceDateStartedIfNull: event.target.name === "dateStarted",
                replaceDateEndIfNull: event.target.name === "dateEnd",
            });

            onUpdate(event.target.name === 'destiny' ? resetUsersDestiny(_notice) : _notice);

        };

        return (
            <ContentInputs>
                <SubContentInputs>
                    <ContentData>
                        <SelectSearchMain<NoticeDestiny>
                            required={true}
                            marginTop={10}
                            marginBottom={25}
                            size={35}
                            label={"Destinatário"}
                            options={destinyMap}
                            onChange={(value) => {

                                handleAllChanges(
                                    {
                                        target:
                                            {
                                                name: 'destiny',
                                                value: value,
                                                checked: false,
                                                type: 'input'
                                            }
                                    })
                            }}
                            value={notice?.destiny ?? '' as any}
                        />

                        {notice?.destiny === NoticeDestiny.client &&
                            <ContentSelectAndCheckBox>
                                <SelectSearchClient
                                    size={35}
                                    useRemoveFilter={!!notice.client}
                                    label={'Empresa'}
                                    placeHolder={"Selecione a empresa"}
                                    handleSelectClient={(value, client) => {
                                        handleAllChanges(
                                            {
                                                target:
                                                    {
                                                        name: 'client',
                                                        value: client,
                                                        checked: false,
                                                        type: 'input'
                                                    }
                                            }, client ?? undefined, undefined, !client);
                                    }}
                                    disabled={loading}
                                    value={notice.client ? {
                                        value: notice.client.id,
                                        label: !!notice.client.socialName ? notice.client.socialName : notice.client.name,
                                    } : undefined}
                                    messageError={errorMessageClient}
                                />
                            </ContentSelectAndCheckBox>}

                        {notice?.destiny === NoticeDestiny.user && <ContentSelectAndCheckBox>
                            <div style={{display: 'flex', flex: 1}}>

                                <SelectSearchUser
                                    size={37}
                                    useRemoveFilter={!!notice.user}
                                    label={'Filtrar por atendente'}
                                    placeHolder={"Selecione o atendente"}
                                    handleSelectUser={(value, user) => {
                                        handleAllChanges(
                                            {
                                                target:
                                                    {
                                                        name: 'user',
                                                        value: user,
                                                        checked: false,
                                                        type: 'input'
                                                    }
                                            },
                                            undefined, user ?? undefined, undefined, !user
                                        );
                                    }}
                                    value={notice.user ? {value: notice.user.id, label: notice.user.name} : undefined}
                                    role={UserRole.attendant}
                                    disabled={loading}
                                    messageError={errorMessageUser}
                                />

                            </div>
                        </ContentSelectAndCheckBox>}


                        <InputWithBorder
                            useEmojiPicker={true}
                            required={true}
                            name='description'
                            size={35}
                            disabled={loading}
                            placeHolder={"Descrição do aviso"}
                            messageError={errorMessageDescription}
                            label={"Descrição"}
                            value={notice?.description ?? ''}
                            onChange={handleAllChanges}
                        />

                        {notice?.hasTemporary &&
                            <div style={{flex: 1, display: 'flex', flexDirection: 'row'}}>
                                <div style={{flex: 1, display: 'flex'}}>
                                    <SelectDateAndTime
                                        value={convertSQLISOToDate(notice.dateStarted)}
                                        placeHolder={'Selecione a data inicial'}
                                        label={'Data Inicial'}
                                        messageError={errorMessageDateStarted}
                                        size={35}
                                        required={true}
                                        minDateFromNow={true}
                                        onChange={(date) => {
                                            const dateToString = date ? date.toISOString() : null;
                                            handleAllChanges(
                                                {
                                                    target:
                                                        {
                                                            name: 'dateStarted',
                                                            value: dateToString,
                                                            checked: false,
                                                            type: 'input'
                                                        }
                                                })
                                        }}
                                    />
                                </div>
                                <div style={{flex: 1, display: 'flex', marginLeft: 10}}>
                                    <SelectDateAndTime
                                        value={convertSQLISOToDate(notice.dateEnd)}
                                        label={'Data Final'}
                                        placeHolder={'Selecione a data final'}
                                        messageError={errorMessageDateEnd}
                                        required={true}
                                        minDateFromNow={true}
                                        size={35}
                                        onChange={(date) => {

                                            const dateToString = date ? date.toISOString() : null;
                                            handleAllChanges(
                                                {
                                                    target:
                                                        {
                                                            name: 'dateEnd',
                                                            value: dateToString,
                                                            checked: false,
                                                            type: 'input'
                                                        }
                                                });
                                        }}
                                    />
                                </div>
                            </div>
                        }
                    </ContentData>
                </SubContentInputs>


                <ContentDataLogin>


                </ContentDataLogin>
            </ContentInputs>
        )
    })
export default InputsFormNotices;
